import { render, staticRenderFns } from "./Padlock.vue?vue&type=template&id=05785f5f&"
import script from "./Padlock.vue?vue&type=script&lang=ts&"
export * from "./Padlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports